// vendors
import { createFeatureSelector, createSelector } from '@ngrx/store';

import { TimesheetInitialState } from './timesheet.state';

// 1. Get the whole feature state
export const selectTimesheetState =
  createFeatureSelector<TimesheetInitialState>('timesheet');

export const selectTimesheetLogs = createSelector(
  selectTimesheetState,
  (state: TimesheetInitialState) => state.logs
);
export const selectAFileNameAndUrl = createSelector(
  selectTimesheetState,
  (state: TimesheetInitialState) => ({
    fileName: state.files.fileName,
    fileUrl: state.files.fileUrl,
  })
);
